import axios from '../axios';
// 微信公告栏表审核
export const auditSysWxAnnouncement = data => {
  return axios({
    url: '/api/sys/sys/auditSysWxAnnouncement',
    method: 'post',
    data
  })
};
// 微信公告栏表删除
export const deleteSysWxAnnouncements = data => {
    return axios({
      url: '/api/sys/sys/deleteSysWxAnnouncements',
      method: 'post',
      data
    })
};
// 微信公告栏表
export const getSysWxAnnouncementPage = data => {
    return axios({
      url: '/api/sys/sys/getSysWxAnnouncementPage',
      method: 'post',
      data
    })
};
// 发布公告栏
export const releaseSysWxAnnouncement = data => {
    return axios({
      url: '/api/sys/sys/releaseSysWxAnnouncement',
      method: 'post',
      data
    })
};
// 发布公告栏下架删除
export const removeSysWxAnnouncement = data => {
    return axios({
      url: '/api/sys/sys/removeSysWxAnnouncement',
      method: 'post',
      data
    })
};
// 发布公告栏下架保存
export const saveSysWxAnnouncement = data => {
    return axios({
      url: '/api/sys/sys/saveSysWxAnnouncement',
      method: 'post',
      data
    })
};
// 发布公告栏下架修改
export const updateSysWxAnnouncement = data => {
    return axios({
      url: '/api/sys/sys/updateSysWxAnnouncement',
      method: 'post',
      data
    })
};


// WEBPACK FOOTER //
// ./src/api/moudules/wx.js